import React from 'react';
import { useTranslation } from 'react-i18next';

require('./NoVideoCalls.css');

export type Props = {
    type: 'active' | 'pending' | 'recent';
};

export const NoVideoCalls = ({ type }: Props) => {
    const { t } = useTranslation();

    const key =
        type === 'active'
            ? 'VIDEO.NO_IN_PROGRESS_CALLS'
            : type === 'pending'
                ? 'VIDEO.NO_PENDING_CALLS'
                : 'VIDEO.NO_RECENT_CALLS';

    return (
        <div className="no-video-calls">
            { t(key) }
        </div>
    );
};
